/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioServicingRoleType = {
    PortfolioManager: 'PORTFOLIO_MANAGER',
    InvestmentAdvisor: 'INVESTMENT_ADVISOR'
} as const;
export type PortfolioServicingRoleType = typeof PortfolioServicingRoleType[keyof typeof PortfolioServicingRoleType];


export function instanceOfPortfolioServicingRoleType(value: any): boolean {
    for (const key in PortfolioServicingRoleType) {
        if (Object.prototype.hasOwnProperty.call(PortfolioServicingRoleType, key)) {
            if (PortfolioServicingRoleType[key as keyof typeof PortfolioServicingRoleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioServicingRoleTypeFromJSON(json: any): PortfolioServicingRoleType {
    return PortfolioServicingRoleTypeFromJSONTyped(json, false);
}

export function PortfolioServicingRoleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioServicingRoleType {
    return json as PortfolioServicingRoleType;
}

export function PortfolioServicingRoleTypeToJSON(value?: PortfolioServicingRoleType | null): any {
    return value as any;
}

export function PortfolioServicingRoleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioServicingRoleType {
    return value as PortfolioServicingRoleType;
}

